export default "/_next/static/images/c81c150b2acce0b4dd5ff6ebc2783339.png";